export enum SocketActions {
  Subscribe = "sub",
  Unsubscribe = "unsub"
}

export enum SocketSubTypes {
  Miner = "miner", // (подписка на майнеры, которые раскрыты нажата more)
  Setting = "setting", // (подписка на график  открытой настройки)
  Hash = "hash", // (подписка на график открытого хеша)
  Location = 'location',
  Object = 'object',
  Client = "user",
}

export interface SocketSubscribe {
  email: string; // User email
  action: SocketActions; // Действие
  type: SocketSubTypes; // тип
  value: any; //  сущность (id майнера, id настройки, хеш и т.д.)
}